export enum EUserRoles {
  ADMINISTRATOR = 'Administrator',
  SALES_REPRESENTATIVE = 'SalesRepresentative',
  CUSTOMER_SUPPORT = 'CustomerSupport',
  ORGANIZATION_ADMINISTRATOR = 'OrganizationAdministrator',
  ORGANIZATION_EDUCATOR = 'OrganizationEducator',
  ORGANIZATION_STUDENT = 'Student',
  PARENT = 'Parent',
  CHILD = 'Child',
}

const UserRolesLabels = new Map<EUserRoles, string>();
UserRolesLabels.set(EUserRoles.ADMINISTRATOR, 'Administrator');
UserRolesLabels.set(EUserRoles.CHILD, 'Child');
UserRolesLabels.set(EUserRoles.CUSTOMER_SUPPORT, 'Customer Support');
UserRolesLabels.set(EUserRoles.ORGANIZATION_ADMINISTRATOR, 'Organization Administrator');
UserRolesLabels.set(EUserRoles.ORGANIZATION_EDUCATOR, 'Organization Educator');
UserRolesLabels.set(EUserRoles.ORGANIZATION_STUDENT, 'Organization Student');
UserRolesLabels.set(EUserRoles.PARENT, 'Parent');
UserRolesLabels.set(EUserRoles.SALES_REPRESENTATIVE, 'Sales Representative');

export { UserRolesLabels };
